import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import ConfirmationTemplate, { ConfirmationTemplateProps } from '../../templates/Confirmation'
import { useHeaderProps } from '../../components/Header/useProps'
import Header from '../../components/Header'
import { actions, selectors } from '../../redux'
import { Screen } from '../../types/global'
import { useSagaTakeEvery } from '../../hooks/useSaga'
import { textareaMocks } from '../../components/form/Textarea/mocks'

const ConfirmationPage: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  // SELECTORS

  const confirmAppointement = useSelector(selectors.app.confirmAppointement)
  const cancelAppointement = useSelector(selectors.app.cancelAppointement)

  // EFFECT

  useSagaTakeEvery(
    actions.app.cancelAppointementSuccess,
    useCallback(() => {
      dispatch(actions.app.getStoresRequest({}))
    }, [dispatch])
  )

  // PROPS

  const headerProps = useHeaderProps()

  const templateProps: ConfirmationTemplateProps = useMemo(() => {
    return {
      layoutProps: {
        header: <Header {...headerProps} />,
      },
      title: t('confirmation.title', {
        name: `${confirmAppointement?.data?.first_name} ${confirmAppointement?.data?.last_name}`,
      }),
      text: t('confirmation.text'),
      textarea: textareaMocks.basic,
      back: {
        label: t('confirmation.back'),
        onClick: () => {
          dispatch(
            actions.app.setScreen({
              screen: Screen.appointement,
            })
          )
        },
      },
      confirmButton: {
        text: t('confirmation.cancel'),
        disabled: cancelAppointement.pending,
        onClick: () => {
          dispatch(
            actions.app.cancelAppointementRequest({
              appointment: confirmAppointement.data!.id,
            })
          )
        },
      },
    }
  }, [cancelAppointement.pending, dispatch, headerProps, confirmAppointement, t])

  // SAGA

  useSagaTakeEvery(
    actions.app.cancelAppointementSuccess,
    useCallback(() => {
      dispatch(
        actions.app.setScreen({
          screen: Screen.appointement,
        })
      )
    }, [dispatch])
  )

  // RETURN

  return <ConfirmationTemplate {...templateProps} />
}

export default ConfirmationPage
